/* eslint-disable @typescript-eslint/prefer-namespace-keyword */
/* eslint-disable @typescript-eslint/no-namespace */
import { ValueTypes } from '@app/core/constants/global-enum';

export namespace SettingsDTO {

    export enum SettingScope {
        system = 1,
        user = 2
    }

    export enum ReleaseStatus {
        release = 0,
        preview = 1,
        alpha = 2,
        beta = 3,
        releaseCandidate = 4
    }

    export enum SettingClientExposure {
        hidden = 0,
        metadataOnly = 1,
        value = 2
    }

    export interface Settings {
        id: string;
        primaryKey: string;
        scope: SettingScope;
        keyGroupTitle: string;
        keyGroup: string;
        icon: string;
        enabledIcon: string;
        disabledIcon: string;
        title: string;
        description: string;
        primaryValue: string;
        defaultValue: string;
        valueType: ValueTypes;
        clientExposure: SettingClientExposure;
        additionalData: string;
        displayOrder: number;
        dependentId: string;
        releaseStatus: ReleaseStatus;
        browsable: boolean;
        externalApplicationId?: string;
        externalApplicationName?: string;
    }


    export interface UserSettings {
        primaryValue: string;
        userId: string;
        settingId: string;
    }

    export interface GenericItem {
        id: string;
        name: string;
        updatedAt?: Date;
    }
}
